import React from "react"
import { Spinner } from "react-bootstrap"
import templateApp from "../Shared/Controller/templateApp"
import { EditImg, DeleteImg } from "../common/ImageConstants";
import { Link } from "react-router-dom";
import * as Constants from "../partials/CommonConstant";
import ConfirmModal from "../common/ConfirmModal";
import NotFound from "../common/NotFound";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import TempalateDataTable from "../template/TempalateDataTable";

class Templates extends templateApp {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      templateList: [],
      showModal: false,
      templateId: "",
      //showDeleteModal: false,
      page: 1,
      perPage: 10,
      totalRows: 0,
      sortBy: "name",
      sortOrder: "asc",      
      searchText: "",
      selectedTemplates: [],
      showBulkDeleteModal: false,
    }
  }
  componentDidMount = () => {
    this.getTemplates();
  }

  handlePageChange = (page) => {
    this.setState({ page }, this.getTemplates);
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ perPage: newPerPage, page }, this.getTemplates);
  };

  // handleSort = (column, sortDirection) => {
  //   this.setState(
  //     {
  //       sortBy: column.selector,
  //       sortOrder: sortDirection,
  //     },
  //     this.getTemplates
  //   );
  // };

  handleSort = (column, sortDirection) => {
    const newSortBy = column.sortField || column.selector;
    
    this.setState((prevState) => ({
      sortBy: newSortBy,
      sortOrder: prevState.sortBy === newSortBy && prevState.sortOrder === "asc" ? "desc" : "asc",
      page: 1, // reset to first page
    }), this.getTemplates);
  };

  handleSearchChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  handleSearchSubmit = () => {
    this.setState({ page: 1 }, this.getTemplates);
  };

  clearSearch = () => {
    this.setState({ searchText: "", page: 1 }, this.getTemplates);
  };

  onBulkDeleteClick = () => {
    this.setState({ showBulkDeleteModal: true });
  }

  handleBulkDelete = () => {
    const idsToDelete = this.state.selectedTemplates.map(row => row.id);
    // Here you can send all selected IDs to your deleteTemplate API
    const promises = idsToDelete.map(id => {
      return this.deleteTemplate({ templateId: id });
    });
    Promise.all(promises).then(() => {
      this.setState({ selectedTemplates: [], showBulkDeleteModal: false });
      this.getTemplates();
    });
  }

  onSelectedRowsChange = ({ selectedRows }) => {
    this.setState({ selectedTemplates: selectedRows });
  }

  getColumnData = (data) => {
    let columnData = "";
    if (data.type === "action") {
      return (
        <div className="edit-icon text-center">
          {/* <Link to={`${Constants.editTemplate}${data.item.id}`} className="ms-2"><img src={EditImg} alt="Edit" title="Edit" /></Link> */}
          <Link to={`${Constants.editTemplate}`.replace(':templateId', `${data.item.id}`)} className="ms-2">
            <img src={EditImg} alt="Edit" title="Edit" />
          </Link>
          <Link to="/" className="ms-2" onClick={(e) => this.onClickDelete(e, data.item.id)}>
            <img src={DeleteImg} alt="Delete" title="Delete" />
          </Link>
        </div>
      );
    }
    return columnData;
  }

  callbackDeleteTemplate = () => {
    this.getTemplates();
  }

  render() {

    const {
      templateList,
      loading,
      page,
      perPage,
      totalRows,
      searchText,
      selectedTemplates
    } = this.state;

    // Create table headers
    const data = this.state.templateList;
    const columns = [
      {
        name: "Template Name",
        selector: row => row.name,
        sortField: "name",
        sortable: true
      },
      {
        name: "Project Name",
        selector: row => row.projectname,
        sortField: "projectname",
        sortable: true,
      },
      {
        name: "# Of Questions",
        selector: row => row.totalquestions,
        sortField: "totalquestions",
        sortable: true
      },
      {
        name: "Action",
        center: true,
        cell: d => { return this.getColumnData({ type: "action", item: d }) }
      }
    ];

    const tableData = {
      columns,
      data
    };

    return (
      <>
        <div className="dashboard-card-wrapper">
          {/* Single Delete Modal */}
          <ConfirmModal show={this.state.showModal}
            onCloseModal={() => this.onCloseModal()}
            module="template"
            confirmClick={() => this.handleDelete()} />

          {/* Bulk Delete Modal */}
          <ConfirmModal
            show={this.state.showBulkDeleteModal}
            onCloseModal={() => this.setState({ showBulkDeleteModal: false })}
            module="template(s)"
            confirmClick={this.handleBulkDelete}
          />

          <div className="row align-items-center">
            <div className="col-12 text-end">
              <Link to={Constants.addTemplate} className="btn btn-blue btn-nex me-2">Add Template</Link>
              <Link to={Constants.deletedTemplates} className="btn btn-blue btn-nex me-2">Deleted Template</Link>
              <Link to={Constants.deletedQuestions} className="btn btn-blue btn-nex">Deleted Questions</Link>
            </div>
          </div>
          <div className="col-md-12 col-sm-12 col-lg-12 mt-3">
            <div className="card-main p-0">
              <div className="dark-table-wrapper table-scroll data-table">

                {/* Custom Search Input */}
                <div className="data-table-extensions d-flex align-items-center">
                
                  {/* Search Row */}                  
                    <div className="data-table-extensions-filter position-relative">

                      <label htmlFor="filterDataTable" className="icon"></label>                        
                      <input
                        type="text"
                        name= "filterDataTable"
                        className="filter-text w-100"
                        placeholder="Search"
                        value={searchText}
                        onChange={(e) => this.setState({ searchText: e.target.value })}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            this.setState({ page: 1 }, this.getTemplates);
                          }
                        }}                       
                      />
                      
                      {searchText && (
                        <span
                          className="clear-icon"
                          onClick={() => {
                            this.setState({ searchText: "", page: 1 }, this.getTemplates);
                          }}
                          style={{
                            position: "absolute",
                            right: "13px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontSize: "23px",
                            color: "#545454"
                          }}
                          title="Clear search"
                        >
                        ×
                        </span>
                      )}

                    </div>
                    
                    <button
                      className="ms-2"
                      title="Click to Search"
                      disabled={searchText.trim() === ""}
                      style={{
                        backgroundColor: searchText.trim() === "" ? "#f4a75f" : "#ee7608", // lighter when disabled
                        color: "white",
                        border: "none",
                        padding: "8px 12px",
                        borderRadius: "50px",
                        cursor: searchText.trim() === "" ? "default" : "pointer"
                      }}
                      onClick={() => {
                        this.setState({ page: 1 }, this.getTemplates);
                      }}
                    >
                      Search
                    </button>
                </div>

                {/* Container : Show selected count + delete button */}
                <div className="data-table-extensions-template d-flex align-items-center">
                    {/* Show selected count + delete button */}
                    {selectedTemplates.length > 0 && (
                      <div className="d-flex justify-content-between align-items-center w-100 selected-item-label">
                        <div>
                          <strong>{selectedTemplates.length}</strong>{' '}
                            {selectedTemplates.length === 1 ? 'item' : 'items'} selected
                        </div>
                        <button
                          className="btn btn-danger"
                           style={{
                            backgroundColor: "#ee7608",
                            border: "none",
                            cursor: "pointer"
                          }}
                          onClick={this.onBulkDeleteClick}
                        >
                          DELETE
                        </button>
                      </div>
                    )}
                </div>

                {this.state.templateList && this.state.templateList.length !== 0 && this.state.loading === false &&
                  <DataTable
                    columns={columns}
                    data={templateList}
                    progressPending={loading}
                    //defaultSortField="name"
                    //defaultSortAsc={true}
                    pagination
                    highlightOnHover
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={perPage}
                    paginationDefaultPage={page}
                    paginationRowsPerPageOptions={[10, 15, 20, 25, 30]}
                    onChangePage={this.handlePageChange}
                    onChangeRowsPerPage={this.handlePerRowsChange}
                    sortServer
                    onSort={this.handleSort}
                    selectableRows                      
                    pointerOnHover
                    permanentDelete={0}
                    callbackDeleteTemplate={this.callbackDeleteTemplate}
                    onSelectedRowsChange={this.onSelectedRowsChange}
                  />
                }
                {this.state.loading === true &&
                  <table className="mb-0 table">
                    <tbody>
                      <tr>
                        <td colSpan={10} className="text-center">
                          <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                }
                {/* Not found */}
                {this.state.loading === false && this.state.templateList && this.state.templateList.length === 0 &&
                  <NotFound message="No Data Found" type="content" />
                }
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
export default Templates